(function(){
  "use strict";

  // Reveal on scroll
  function initReveal(){
    var els = document.querySelectorAll(".reveal");
    if(!els.length) return;
    if(!("IntersectionObserver" in window) || window.matchMedia("(prefers-reduced-motion: reduce)").matches){
      els.forEach(function(el){ el.classList.add("is-visible"); });
      return;
    }
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if(entry.isIntersecting){
          entry.target.classList.add("is-visible");
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0, rootMargin: "0px 0px -8% 0px" });
    els.forEach(function(el){ io.observe(el); });
  }

  // Hide in-page anchor links whose target section isn't on this page (e.g. empty course/reviews)
  function initAnchorGuard(){
    document.querySelectorAll(".anchor-nav__links a[href*='#']").forEach(function(a){
      var href = a.getAttribute("href");
      var parts = href.split("#");
      var path = parts[0] || window.location.pathname;
      if(path !== window.location.pathname && path !== "/") return;
      if(parts[1] && !document.getElementById(parts[1])) a.hidden = true;
    });
  }

  // Buy gallery: thumbnail click + prev/next
  function initGallery(){
    document.querySelectorAll("[data-gallery]").forEach(function(gallery){
      var main = gallery.querySelector("[data-gallery-main]");
      var thumbs = Array.prototype.slice.call(gallery.querySelectorAll("[data-gallery-thumb]"));
      if(!main || !thumbs.length) return;
      var active = 0;
      function show(i){
        active = (i + thumbs.length) % thumbs.length;
        var src = thumbs[active].getAttribute("data-full");
        var img = main.querySelector("img");
        if(img && src) img.src = src;
        thumbs.forEach(function(t, idx){ t.classList.toggle("is-active", idx === active); });
      }
      thumbs.forEach(function(t, idx){
        t.addEventListener("click", function(){ show(idx); });
      });
      gallery.querySelectorAll("[data-gallery-prev]").forEach(function(btn){
        btn.addEventListener("click", function(){ show(active - 1); });
      });
      gallery.querySelectorAll("[data-gallery-next]").forEach(function(btn){
        btn.addEventListener("click", function(){ show(active + 1); });
      });
    });
  }

  // Course week chips
  function initWeekChips(){
    document.querySelectorAll("[data-week-chips]").forEach(function(wrap){
      var chips = Array.prototype.slice.call(wrap.querySelectorAll("[data-week-chip]"));
      var panels = Array.prototype.slice.call(document.querySelectorAll("[data-week-panel]"));
      chips.forEach(function(chip){
        chip.addEventListener("click", function(){
          var week = chip.getAttribute("data-week-chip");
          chips.forEach(function(c){ c.setAttribute("aria-pressed", c === chip ? "true" : "false"); });
          panels.forEach(function(p){ p.classList.toggle("is-active", p.getAttribute("data-week-panel") === week); });
        });
      });
    });
  }

  // Sticky buy bar: show once hero/buy button scrolls past
  function initStickyBar(){
    var bar = document.querySelector("[data-sticky-bar]");
    var trigger = document.querySelector("[data-sticky-trigger]");
    if(!bar || !trigger) return;
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        bar.classList.toggle("is-visible", !entry.isIntersecting && entry.boundingClientRect.top < 0);
      });
    }, { threshold: 0 });
    io.observe(trigger);
  }

  // Mobile nav toggle
  function initMobileNav(){
    var toggle = document.querySelector("[data-nav-toggle]");
    var links = document.querySelector("[data-nav-links]");
    if(!toggle || !links) return;
    toggle.addEventListener("click", function(){
      var open = links.classList.toggle("is-open");
      toggle.setAttribute("aria-expanded", open ? "true" : "false");
    });
  }

  // Quantity stepper
  function initQtyStepper(){
    document.querySelectorAll("[data-qty-stepper]").forEach(function(stepper){
      var input = stepper.querySelector("input");
      if(!input) return;
      stepper.querySelectorAll("[data-qty-minus]").forEach(function(btn){
        btn.addEventListener("click", function(){
          input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
        });
      });
      stepper.querySelectorAll("[data-qty-plus]").forEach(function(btn){
        btn.addEventListener("click", function(){
          input.value = (parseInt(input.value, 10) || 1) + 1;
        });
      });
    });
  }

  document.addEventListener("DOMContentLoaded", function(){
    initReveal();
    initAnchorGuard();
    initGallery();
    initWeekChips();
    initStickyBar();
    initMobileNav();
    initQtyStepper();
  });
})();
